<template>
    <section>
      <el-dialog
        title="配置模版"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="editForm"
          label-width="120px"
          :rules="editFormRules"
          ref="editForm"
        >
          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="是否需要分屏" prop="Seperate">
            <el-radio-group v-model="editForm.Seperate">
              <el-radio-button label="1">是</el-radio-button>
              <el-radio-button label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="分屏方式" prop="SeperateType">
            <el-radio-group v-model="editForm.SeperateType">
              <el-radio-button label="1">上下</el-radio-button>
              <el-radio-button label="0">左右</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="默认分屏方式" prop="DefaultSeperate">
            <el-radio-group v-model="editForm.DefaultSeperate">
              <el-radio-button label="1">全屏</el-radio-button>
              <el-radio-button label="0">半屏</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="开始按钮X坐标" prop="StartX">
            <el-input-number
                v-model="editForm.StartX"
                :min="0"
                :max="50000"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="开始按钮Y坐标" prop="StartY">
            <el-input-number
                v-model="editForm.StartY"
                :min="0"
                :max="50000"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="webview链接" prop="UrlPath">
            <el-input v-model="editForm.UrlPath" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="虚拟人背景图" prop="BackgroundUrl">
            <el-input v-model="editForm.BackgroundUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="调用大模型地址" prop="AiModelUrl">
            <el-input v-model="editForm.AiModelUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="上传对话内容路径" prop="ContentBackUrl">
            <el-input v-model="editForm.ContentBackUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="空闲几秒退出" prop="FreeTime">
            <el-input-number
                v-model="editForm.FreeTime"
                :min="0"
                :max="300"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="虚拟人包下载地址" prop="AiPackUrl">
            <el-input v-model="editForm.AiPackUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="虚拟人形象地址" prop="HumanUrl">
            <el-input v-model="editForm.HumanUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="虚拟空闲播放视频" prop="HumanVideoUrl">
            <el-input v-model="editForm.HumanVideoUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="数字人模型" prop="AiModelSourceUrl">
            <el-input v-model="editForm.AiModelSourceUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="对话二维码链接" prop="DialogBarCodeUrl">
            <el-input v-model="editForm.DialogBarCodeUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="APPID" prop="AppId">
            <el-input v-model="editForm.AppId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="AppKey" prop="AppKey">
            <el-input v-model="editForm.AppKey" auto-complete="off"></el-input>
          </el-form-item>

         <el-form-item label="APP链接" prop="AppUrl">
            <el-input v-model="editForm.AppUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="APP版本" prop="AppVersion">
            <el-input v-model="editForm.AppVersion" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="Token" prop="Token">
            <el-input v-model="editForm.Token" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="备注1" prop="Remark1">
            <el-input v-model="editForm.Remark1" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="备注2" prop="Remark2">
            <el-input v-model="editForm.Remark2" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="备注3" prop="Remark3">
            <el-input v-model="editForm.Remark3" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  
  
  <script>
  import { editMachinesConfig,getMachinesConfigByMachineID, BaseApiUrl } from "../../api/api";
  export default {
    props: {
        editForm:{}
    },
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        editFormVisible:true,
        options: [],
        addLoading: false,
        clinicLoading:false,
        editFormRules: {
         
        },
      };
    },
    methods: {
        remoteMethod(query){  //获取机器分组
            var that = this;
            console.log(111111);
            
            that.clinicLoading = true;
            var para = {
                key: query,
            };
      },
      closetc(index) { 
        this.$parent.closetc(); //将值传给父组件 
      },
      //新增
      addSubmit: function () {
        let _this = this;
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
              
              editMachinesConfig(para).then((res) => {
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
     
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
     

    },
  };
  </script> 